import type { EventCard } from '../types';

export const events: EventCard[] = [
  {
    id: 'emergency',
    type: 'event',
    title: 'Emergency expense',
    description: 'A real life surprise hits. Cash absorbs it; debt magnifies it.',
    cost: 950,
    expenseChange: 0,
    required: true,
    lesson: 'Runway is a financial shock absorber.',
  },
  {
    id: 'bonus',
    type: 'event',
    title: 'Unexpected bonus',
    description: 'Extra money appears. It can become capital, snowball fuel, or a doodad story.',
    cost: -1800,
    expenseChange: 0,
    required: true,
    lesson: 'Windfalls reveal the plan you already had.',
  },
  {
    id: 'rent-up',
    type: 'event',
    title: 'Rent and groceries rise',
    description: 'Inflation nudges the run rate higher unless you actively redesign expenses.',
    cost: 0,
    expenseChange: 160,
    required: true,
    lesson: 'Expense drift quietly moves the FIRE line.',
  },
  {
    id: 'referral',
    type: 'event',
    title: 'A referral improves active income',
    description: 'Your reputation creates a higher-paying opportunity.',
    cost: 0,
    incomeChange: 420,
    lesson: 'Skills and network are assets even when they are not on the balance sheet.',
  },
  {
    id: 'repair',
    type: 'event',
    title: 'Car repair',
    description: 'Not glamorous, but transportation keeps active income alive.',
    cost: 700,
    expenseChange: 0,
    required: true,
    lesson: 'Some expenses protect the income engine.',
  },
  {
    id: 'new-baby',
    type: 'event',
    title: 'A child joins the family',
    description: 'Life changes. This is not optional; you adjust the financial statement and keep moving.',
    cost: 900,
    expenseChange: 0,
    familyAction: 'addKid',
    required: true,
    lesson: 'Kids consume time and increase expenses, but the game is still winnable.',
  },
  {
    id: 'marriage',
    type: 'event',
    title: 'You get married',
    description: 'Responsibilities and expenses change, and kid time can now be shared.',
    cost: 1200,
    expenseChange: 0,
    familyAction: 'marry',
    required: true,
    lesson: 'Marriage can add costs but also share family time obligations.',
  },
  {
    id: 'divorce',
    type: 'event',
    title: 'Divorce reshapes the household',
    description: 'Cash and every asset split 50/50 with your spouse. Legal fees and a single-household premium come on top.',
    cost: 2500,
    expenseChange: 350,
    familyAction: 'divorce',
    required: true,
    lesson: 'Marriage is the largest financial entanglement most people enter. Walking out is rarely a clean exit.',
  },
  {
    id: 'childcare-gap',
    type: 'event',
    title: 'Childcare gap',
    description: 'A schedule change forces paid help or lost work capacity this month.',
    cost: 450,
    expenseChange: 120,
    required: true,
    lesson: 'Family logistics show up as both time and money pressure.',
  },
  {
    id: 'promotion-more-hours',
    type: 'event',
    title: 'Promotion offer with longer hours',
    description: 'The raise is real, but the job gets heavier and crowds out deal flow.',
    cost: 0,
    incomeChange: 900,
    expenseChange: 120,
    lesson: 'Active income can rise while freedom gets farther away if expenses and time pressure rise too.',
  },
  {
    id: 'insurance-rate-hike',
    type: 'event',
    title: 'Insurance renewal jumps',
    description: 'No drama, just a higher monthly bill you now have to absorb.',
    cost: 0,
    expenseChange: 95,
    required: true,
    lesson: 'The run rate drifts upward unless you actively manage it.',
  },
  {
    id: 'tax-refund',
    type: 'event',
    title: 'Tax refund arrives',
    description: 'A lump sum shows up. The statement will reveal whether it becomes freedom or consumption.',
    cost: -2400,
    expenseChange: 0,
    required: true,
    lesson: 'Windfalls are accelerants, not plans.',
  },
  {
    id: 'parent-needs-help',
    type: 'event',
    title: 'Parent needs help',
    description: 'Family responsibility increases for a season. You cannot optimize every human obligation away.',
    cost: 600,
    expenseChange: 100,
    required: true,
    lesson: 'A resilient plan has margin for people, not just assets.',
  },
  {
    id: 'layoff-scare',
    type: 'event',
    title: 'Layoff scare cuts hours',
    description: 'Your active income dips. Cash flow reveals how fragile the plan is.',
    cost: 0,
    incomeChange: -650,
    expenseChange: 0,
    required: true,
    lesson: 'Depending only on active income is a concentration risk.',
  },
];
